import React from 'react'
import Meta from '@/components/common/Meta'
import BookNowForm from '@/components/book-storage-facility/bookNowForm'
import {
  book_now_benefits,
  book_now_what_you_should_know,
  titleWithDetails
} from '@/components/book-storage-facility/Contents'
import IconList from '@/components/subComponents/iconList'
import Promotion from '@/components/sections/Promotion'
import { assets } from '@/helpers/common'
import { META_CONTENTS } from '@/v1/constants/seo'

const BookStorageFacility = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.book_storage_facility.title}
        keywords={META_CONTENTS.book_storage_facility.keywords}
        description={META_CONTENTS.book_storage_facility.description}
      />

      <BookNowForm />

      <section className='what-you-should-know pt-8 md-mx:pt-6 sm-mx:pt-10'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h1 className='inline-block'>What You Should Know</h1>
                <p>
                  We make storage simple based on your needs. Read the information below to know more about{' '}
                  <br className='md-mx:hidden' />
                  storage facilities and items that you can store and ship with us
                </p>
              </div>
            </div>
          </div>
          <div className='pt-12 grid gap-x-20 lg-mx:gap-x-5 gap-y-10 lg-mx:gap-y-5 grid-cols-3 sm-mx:grid-cols-2 xs:grid-cols-1'>
            {book_now_what_you_should_know}
          </div>
        </div>
      </section>

      <section className='benefits-section pt-24 pb-14 md-mx:pt-12 sm-mx:pt-10'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>Added Benefits</h2>
                <p>We care about your demands and affordability and brought the best solution for you! </p>
              </div>
            </div>
          </div>
          <div className='pt-12 grid gap-x-20 lg-mx:gap-x-5 gap-y-10 lg-mx:gap-y-5 grid-cols-3 sm-mx:grid-cols-2 xs:grid-cols-1'>
            {book_now_benefits}
          </div>
        </div>
      </section>

      <section className='safe-services-section bg-white-ice pt-14 pb-14 md-mx:pt-12 sm-mx:pt-10'>
        <div className='container'>
          <div className='row md-mx:flex-col-reverse'>
            <div className='w-6/12 md-mx:w-full md-mx:text-center sm-mx:text-left'>
              <div className='section-title'>
                <h2>
                  Safe, secure, reliable and <br />
                  affordable storage service
                </h2>
              </div>
              <p>
                Ship and Storage is storage space provider to stow all your household items with state of the art
                security facilities, Catering exclusive cheap storage solutions ranging from Household items storage to{' '}
              </p>
              <IconList listData={titleWithDetails.safe_service} linkDisable listIcon />
            </div>
            <div className='w-6/12 md-mx:w-full text-right md-mx:text-center sm-mx:hidden'>
              <img src={assets('images/book-now/safe_services.png')} className='inline-block' alt={''} />
            </div>
          </div>
        </div>
      </section>

      <Promotion />
    </>
  )
}

export default BookStorageFacility
